import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

export const useGetCurrencyGains = ({
  filters,
}: {
  filters: {
    base_currency_id: number
    include_equity: number
    startDate: string
    endDate: string
  }
}): UseQueryResult<{ data: number }, Error> => {
  const queryParams = useBuildQueryParams(filters)
  return useQuery(
    ['reports', 'currency', 'gains', { queryParams }],
    () =>
      request<{ data: number }>({
        url: '/reports/currency/gains',
        method: 'GET',
        params: {
          ...queryParams,
        },
      }),
    {
      enabled: !!queryParams,
    },
  )
}
